enum DeliveryTypeEnum {
    ONLINE = 'ONLINE',
    DELIVERY_CARRIER = 'DELIVERY_CARRIER',
}

export default DeliveryTypeEnum;
